import type { Schema } from "../../../core/render/logic/Markdoc/index";

export const strikethrough: Schema = {
	render: "s",
};
